import { c as _c } from "react/compiler-runtime";
import { EMAIL_STATISTICS_API } from 'modules/mailing/email-statistics/api/email-statistics-api';
import { EmailPreviewInterface } from 'modules/mailing/email-statistics/types/email-preview-interface';
import { EmailId } from 'shared/components/dashboard-mail-editor/types/email-interface';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
interface useEmailPreviewProps {
  emailId: EmailId;
}
export function useEmailPreview(t0) {
  const $ = _c(7);
  const {
    emailId
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== emailId) {
    t2 = () => [`${EMAIL_STATISTICS_API}/${emailId}/preview`, RequestModuleEnum.CampaignStep];
    $[1] = emailId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== fetcher) {
    t3 = url => fetcher(url);
    $[3] = fetcher;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: emailPreviewData
  } = useControlledSwr(t2, t3, undefined, !!user);
  let t4;
  if ($[5] !== emailPreviewData) {
    t4 = {
      emailPreviewData
    };
    $[5] = emailPreviewData;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}